/* eslint-disable camelcase */
import axios from "axios";
import { notification } from "ant-design-vue";
import Axios from "axios";
import Repository from "../../repositories/Repository";

const getDefaultState = () => {
  return {
    claimProfile: {
      showFilters: false,
      hideFiltersToggle: false,
      searchFirstName: "",
      searchLastName: "",
      searchCity: "",
      searchState: "",
      searchSpeciality: "",
      searchGender: "",
      doctorsList: {},
      filteredDoctorsList: [],
      selectedDoctorProfile: {}
    },
    welcome: {
      user: {}
    },
    symptoms: {
      symptoms: []
    },
    treatments: {
      treatmentsArr: []
    },
    yourStory: "",
    userTypeSelect: null,
    hospitalsList: {},
    filteredHospitalsList: [],
    clinicsList: {},
    filteredClinicsList: [],
    NFPList: {},
    filteredNFPList: [],
    otherHPList: {},
    filteredOtherHPList: [],
    isFetchingStoreData: false,
    count:0
  };
};

const state = getDefaultState();

const actions = {
  getDoctors: ({ commit }, filters) => {
    commit("setIsFetchingData", { data: true });

    const response = {};
    // let url =
    //   `https://stage.k8s.dovemed.com/mycircles/api/doctorsearch/?is_active_physician=true&circle_id=${filters.circle_id}`;
    let url = `${process.env.BASE_API_URL}/doctorsearch/?is_active_physician=true&circle_id=${filters.circle_id}`;

    if (filters.searchFirstName) {
      url += "&first_name=" + filters.searchFirstName;
    }
    if (filters.searchLastName) {
      url += "&last_name=" + filters.searchLastName;
    }
    if (filters.searchCity) {
      url += "&city=" + filters.searchCity;
    }
    if (filters.searchSpeciality) {
      url += "&speciality=" + filters.searchSpeciality;
    }
    if (filters.searchGender) {
      url += "&gender=" + filters.searchGender;
    }
    if (filters.searchState) {
      url += "&state=" + filters.searchState;
    }
    if (filters.page) {
      url += "&page=" + filters.page;
    }

    Repository.get(url)
      .then(result => {
        response.data = result.data;
        if (result.data.results.length > 0) {
          response.showFilter = true;
        }
        commit("setDoctors", response);
        commit("setIsFetchingData", { data: false });
      })
      .catch(err => console.error(err));
  },

  getDoctorsPage: ({ commit }, filters) => {
    const response = {};
    let url =
      `${process.env.SSO_BASE_URL}/api/v1/physician/physician-search/?is_active_physician=true`;
    if (filters.searchFirstName) {
      url += "&first_name=" + filters.searchFirstName;
    }
    if (filters.searchLastName) {
      url += "&last_name=" + filters.searchLastName;
    }
    if (filters.searchCity) {
      url += "&city=" + filters.searchCity;
    }
    if (filters.searchSpeciality) {
      url += "&speciality=" + filters.searchSpeciality;
    }
    if (filters.searchGender) {
      url += "&gender=" + filters.searchGender;
    }
    if (filters.next_page) {
      url += "&page=" + filters.next_page;
    }
    axios
      .get(url)
      .then(result => {
        response.showFilters = true;
        response.data = result.data;
        commit("setDoctorsPage", response);
      })
      .catch(err => console.error(err));
  },

  createUser({ commit }, { payload }) {
    const url = `${process.env.BASE_API_URL}/${
      payload.role === "patient" ? "user" : payload.role
    }create/`;
    // caregivercreate
    // advocatecreate
    return axios
      .post(url, payload)
      .then(res => {
        const userData = {
          user: {
            ...res.data.data.user[0],
            multiRole: res.data.data.user[0].role,
            role: payload.role
          }
        };
        console.log("User Data in createUser is ", userData);
      
        commit("User/setUser", { data: userData }, { root: true });
        return Promise.resolve(res.data.data);
      })
      .catch(err => {
        // notification.error({
        //   message: "Error",
        //   description: err.response.data.message
        // });
        return Promise.reject(err.response.data.message);
      });
  },

  updateUserCircle({ state, commit }, { url, payload, headers }) {
    return axios
      .put(url, payload, { headers: headers })
      .then(res => {
        // commit('User/updateUserCircle', {data: res.data.data[0]}, { root: true })
      })
      .catch(err => {
        console.error(err);
      });
  },

  updateNormalUser({ state, commit }, { url, payload, headers }) {
    return axios
      .put(url, payload, { headers: headers })
      .then(res => {})
      .catch(err => {
        console.error(err);
      });
  },

  getTreatment: ({ commit }, { url, payload, headers }) => {
    return axios
      .get(url, payload, { headers: headers })
      .then(result => {
        commit("setTreatment", result.data);
      })
      .catch(err => {
        console.error(err);
      });
  },

  setTreatment: ({ commit }, { url, payload, headers }) => {
    return axios
      .post(url, payload, { headers: headers })
      .then(result => {
        // notification.success({
        //   message: "Success",
        //   description: "Treatment Added Successfully"
        // });
        commit("setTreatment", result.data);
      })
      .catch(err => {
        console.error(err);
        notification.error({
          message: "Error",
          description: "Error Adding Treatment"
        });
      });
  },

  updateTreatment: ({ commit }, { url, payload, headers }) => {
    return axios
      .put(url, payload, { headers: headers })
      .then(result => {
        // notification.success({
        //   message: "Success",
        //   description: "Treatment Added Successfully"
        // });
        commit("updateTreatment", result.data);
      })
      .catch(err => {
        console.error(err);
        notification.error({
          message: "Error",
          description: "Error Adding Treatment"
        });
      });
  },

  removeTreatment: ({ commit }, { url, payload, headers }) => {
    return axios
      .delete(url, { headers: headers })
      .then(result => {
        commit("removeTreatment", payload);
      })
      .catch(err => {
        console.error(err);
      });
  },

  setStory: ({ commit }, { url, payload, headers }) => {
    return axios
      .post(url, payload, { headers: headers })
      .then(result => {
        commit("setStory", result.data);
      })
      .catch(err => {
        console.error(err);
      });
  },

  resetSignupState({ commit }) {
    commit("resetState");
  },

  getHospitals: ({ commit }, filters) => {
    commit("setIsFetchingData", { data: true });
    const response = {};
    let url = `${process.env.BASE_API_URL}/hospitalsearch/`;
    Object.keys(filters).forEach((rs, i) => {
      url += i ? `&${rs}=${filters[rs]}` : `?${rs}=${filters[rs]}`;
    });

    Repository.get(url)
      .then(result => {
        response.data = result.data;
        if (result.data.results.length > 0) {
          response.showFilter = true;
        }
        commit("setHospitals", response);
        commit("setIsFetchingData", { data: false });
      })
      .catch(err => console.error(err));
  },
  getClinics: ({ commit }, filters) => {
    commit("setIsFetchingData", { data: true });

    const response = {};
    let url = `${process.env.BASE_API_URL}/clinicsearch/`;
    Object.keys(filters).forEach((rs, i) => {
      url += i ? `&${rs}=${filters[rs]}` : `?${rs}=${filters[rs]}`;
    });
    Repository.get(url)
      .then(result => {
        response.data = result.data;
        if (result.data.results.length > 0) {
          response.showFilter = true;
        }
        commit("setClinics", response);
        commit("setIsFetchingData", { data: false });
      })
      .catch(err => console.error(err));
  },
  getOHCP: ({ commit }, filters) => {
    commit("setIsFetchingData", { data: true });
    const response = {};
    let url = `${process.env.BASE_API_URL}/hcpsearch/`;
    Object.keys(filters).forEach((rs, i) => {
      url += i ? `&${rs}=${filters[rs]}` : `?${rs}=${filters[rs]}`;
    });
    Repository.get(url)
      .then(result => {
        response.data = result.data;
        if (result.data.results.length > 0) {
          response.showFilter = true;
        }
        commit("setOHCP", response);
        commit("setIsFetchingData", { data: false });
      })
      .catch(err => console.error(err));
  },
  getNFP: ({ commit }, filters) => {
    commit("setIsFetchingData", { data: true });

    const response = {};
    let url = `${process.env.BASE_API_URL}/nfpsearch/`;
    Object.keys(filters).forEach((rs, i) => {
      url += i ? `&${rs}=${filters[rs]}` : `?${rs}=${filters[rs]}`;
    });
    Repository.get(url)
      .then(result => {
        response.data = result.data;
        if (result.data.results.length > 0) {
          response.showFilter = true;
        }
        commit("setNFP", response);
        commit("setIsFetchingData", { data: false });
      })
      .catch(err => console.error(err));
  }
};

const getters = {
  treatments: state => state.treatments,
  userTypeSelect: state => state.userTypeSelect,
  isFetchingStoreData: state => state.isFetchingStoreData
};

const mutations = {
  setIsFetchingData: (state, { data }) => {
    state.isFetchingStoreData = data;
  },

  setDoctors: (state, { showFilters, data }) => {
    state.claimProfile.showFilters = showFilters;
    state.claimProfile.doctorsList = data;
    state.claimProfile.filteredDoctorsList = [...data.results];
  },

  setDoctorsPage: (state, { showFilters, data }) => {
    state.claimProfile.showFilters = showFilters;
    state.claimProfile.doctorsList = data;
    state.claimProfile.filteredDoctorsList = [...data.results];
  },

  createUser: (state, { data: { user, user_circle } }) => {
    state.welcome.user = { ...user[0] };
    state.welcome.user.user_circle = user_circle;
    localStorage.setItem("token", state.welcome.user.token);
  },

  updateUserCircle: (state, { data }) => {
    state.welcome.user.symptoms = { ...data[0] };
  },

  setTreatment: (state, { data }) => {
    state.treatments.treatmentsArr.push(data);
  },

  updateTreatment: (state, { data }) => {
    state.treatments.treatmentsArr = [
      ...state.treatments.treatmentsArr.filter(item => item.id !== data.id),
      data
    ];
  },

  removeTreatment: (state, { id }) => {
    const newArray = state.treatments.treatmentsArr.filter(
      item => item.id !== id
    );

    state.treatments.treatmentsArr = newArray;
  },

  setStory: (state, { data }) => {
    state.yourStory = data;
  },

  setUserTypeSelection: (state, data) => {
    state.userTypeSelect = data;
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },

  setHospitals: (state, { showFilters, data }) => {
    const newData = {
      filters: data.filter,
      has_next: data.has_next,
      has_previous: data.has_previous,

      next_page: data.next_Page + 1,
      page: data.page + 1,
      previous_page: data.previous_page + 1,
      results: data.results,
      search_time: data.search_time,
      total_hits: data.total_hits,
      total_pages: data.total_pages
    };
    state.claimProfile.showFilters = showFilters;
    state.hospitalsList = newData;
    state.filteredHospitalsList = [...newData.results];
  },
  setClinics: (state, { showFilters, data }) => {
    state.claimProfile.showFilters = showFilters;
    state.clinicsList = data;
    state.filteredClinicsList = [...data.results];
  },
  setOHCP: (state, { showFilters, data }) => {
    state.claimProfile.showFilters = showFilters;
    state.otherHPList = data;
    state.filteredOtherHPList = [...data.results];
  },
  setNFP: (state, { showFilters, data }) => {
    state.claimProfile.showFilters = showFilters;
    state.NFPList = data;
    state.filteredNFPList = [...data.results];
  },
  increment:(state) =>{
    state.count++
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Signup.js